<template>
  <div class="area-select">
    <el-cascader
      style="width: 100%"
      :props="cascaderProps"
      ref="areaSelectRef"
      v-model="areaIds"
      placeholder="请选择"
      :collapse-tags="true"
      :collapse-tags-tooltip="true"
      clearable
      filterable
      @change="change"
    />
  </div>
</template>

<script setup>
import { regionProvince, regionCity, regionCounty } from "@/api/areaSelect/index.js";
import { useFormItem } from "element-plus";
const { form, formItem } = useFormItem();

const areaSelectRef = ref();

const props = defineProps({
  modelValue: {
    type: String,
    default: "",
  },
  name: {
    type: String,
    default: "",
  },
});

const areaIds = ref([]);
const cascaderProps = {
  value: "id",
  label: "name",
  lazy: true,
  lazyLoad: async (node, resolve) => {
    const { level, value } = node;
    const api = [regionProvince, regionCity, regionCounty][level];
    const nodes = (await api(value)).data.map((item) => Object.assign({}, item, { leaf: level >= 2 }));
    resolve(nodes);
  },
};

const change = () => {
  emits("update:modelValue", (areaIds.value && areaIds.value.join(",")) || "");

  const [area] = areaSelectRef.value.getCheckedNodes();
  emits("update:name", (area && area.text) || "");
  formItem?.validate?.("change");
};

const emits = defineEmits(["update:modelValue", "update:name"]);

watch(
  () => props.modelValue,
  () => {
    areaIds.value = (props.modelValue && props.modelValue.split(",")) || [];
  },
  { immediate: true }
);
</script>

<style lang="scss" scoped>
.area-select {
}
</style>
